import React from 'react';
import { FiCheckCircle, FiAlertCircle, FiX, FiInfo } from 'react-icons/fi';
import Modal from './Modal';

const AlertModal = ({ isOpen, onClose, type = 'success', title, message, onConfirm }) => {
  if (!isOpen) return null;

  const icons = {
    success: <FiCheckCircle className="w-6 h-6 text-green-600" />,
    error: <FiAlertCircle className="w-6 h-6 text-red-600" />,
    info: <FiInfo className="w-6 h-6 text-blue-600" />,
    warning: <FiAlertCircle className="w-6 h-6 text-yellow-600" />
  };

  const colors = {
    success: {
      bg: 'bg-green-50',
      border: 'border-green-200',
      iconBg: 'bg-green-100',
      button: 'bg-green-600 hover:bg-green-700'
    },
    error: {
      bg: 'bg-red-50',
      border: 'border-red-200',
      iconBg: 'bg-red-100',
      button: 'bg-red-600 hover:bg-red-700'
    },
    info: {
      bg: 'bg-blue-50',
      border: 'border-blue-200',
      iconBg: 'bg-blue-100',
      button: 'bg-blue-600 hover:bg-blue-700'
    },
    warning: {
      bg: 'bg-yellow-50',
      border: 'border-yellow-200',
      iconBg: 'bg-yellow-100',
      button: 'bg-yellow-600 hover:bg-yellow-700'
    }
  };

  const colorScheme = colors[type] || colors.success;

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm">
      <div className={`${colorScheme.bg} ${colorScheme.border} border-2 rounded-xl p-6`}>
        <div className="flex items-start gap-4">
          <div className={`${colorScheme.iconBg} rounded-full p-3 flex-shrink-0`}>
            {icons[type] || icons.success}
          </div>
          <div className="flex-1 min-w-0">
            {title && (
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                {title}
              </h3>
            )}
            <p className="text-sm text-gray-700 whitespace-pre-wrap">
              {message}
            </p>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors flex-shrink-0"
          >
            <FiX className="w-5 h-5" />
          </button>
        </div>
        <div className="mt-6 flex justify-end">
          <button
            onClick={() => {
              if (onConfirm) onConfirm();
              onClose();
            }}
            className={`${colorScheme.button} text-white px-6 py-2.5 rounded-lg font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-${type === 'success' ? 'green' : type === 'error' ? 'red' : type === 'warning' ? 'yellow' : 'blue'}-500`}
          >
            OK
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default AlertModal;
